<template>
  <BaseTemplate app-name="HelpDesk" page-title="">
      <template #content>
          <div class="flex h-screen bg-gray-50 dark:bg-gray-900">
              <!-- Mobile Overlay -->
              <div 
                  v-if="sidebarOpen" 
                  class="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
                  @click="sidebarOpen = false"
              ></div>

              <!-- Sidebar -->
              <div 
                  :class=" [
                      'fixed inset-y-0 left-0 z-50 w-64 bg-white dark:bg-gray-800 shadow-lg border-r border-gray-200 dark:border-gray-700 transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0',
                      sidebarOpen ? 'translate-x-0' : '-translate-x-full'
                  ]"
              >
                  <div class="p-4 border-b border-gray-200 dark:border-gray-700">
                      <div class="flex items-center justify-between">
                          <div class="flex items-center space-x-3">
                              <div class="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                                  <Headset class="w-6 h-6 text-white" />
                              </div>
                              <div>
                                  <h2 class="font-semibold text-gray-900 dark:text-white">Central de Ajuda CCDTI</h2>
                              </div>
                          </div>
                          <button 
                              @click="sidebarOpen = false"
                              class="lg:hidden p-2 rounded-md text-gray-400 dark:text-gray-300 hover:text-gray-600 dark:hover:text-gray-100"
                          >
                              <X class="w-5 h-5" />
                          </button>
                      </div>
                  </div>
                  
                  <nav class="p-4 space-y-2">
                      <a
                          href="#"
                          @click="currentView = 'dashboard'"
                          :class="currentView === 'dashboard' ? 'bg-blue-50 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'"
                          class="flex items-center space-x-3 px-3 py-2 rounded-lg"
                      >
                          <LayoutDashboard class="w-5 h-5" />
                          <span class="font-medium">Dashboard</span>
                      </a>
                      <a
                          v-if="isTIUser"
                          href="#"
                          @click="currentView = 'tickets'"
                          :class="currentView === 'tickets' ? 'bg-blue-50 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'"
                          class="flex items-center space-x-3 px-3 py-2 rounded-lg"
                      >
                          <Ticket class="w-5 h-5" />
                          <span class="font-medium">Todos os Chamados</span>
                      </a>
                      <a
                          href="#"
                          @click.prevent="showMyAssigned"
                          :class="currentView === 'myAssigned' ? 'bg-blue-50 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'"
                          class="flex items-center space-x-3 px-3 py-2 rounded-lg"
                      >
                          <User class="w-5 h-5" />
                          <span class="font-medium">Meus Chamados</span>
                      </a>
                      <a
                          href="#"
                          @click="currentView = 'settings'"
                          :class="currentView === 'settings' ? 'bg-blue-50 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'"
                          class="flex items-center space-x-3 px-3 py-2 rounded-lg"
                      >
                          <Settings class="w-5 h-5" />
                          <span class="font-medium">Configuração</span>
                      </a>
                      
<div v-if="currentView === 'tickets' && isTIUser" class="space-y-1">
        <!-- Filtros adicionais -->
        <div class="mt-4 space-y-2">
                      <p class="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider px-3 mt-2">Filas</p>
<label v-for="fila in filas" :key="'fila-filter-' + fila.id" class="flex items-center space-x-2 px-3 py-1 text-sm">
    <input type="checkbox" :value="fila.nome" v-model="selectedFilas" class="rounded text-green-500 focus:ring-green-500 dark:bg-gray-700 dark:border-gray-600" />
    <span class="text-gray-700 dark:text-gray-300">{{ fila.nome }}</span>
</label>
            <p class="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider px-3 mt-2">Prioridade</p>
<label v-for="priority in priorityOptions" :key="priority.value" class="flex items-center space-x-2 px-3 py-1 text-sm">
    <input type="checkbox" :value="priority.value" v-model="selectedPriorities" class="rounded text-yellow-500 focus:ring-yellow-500 dark:bg-gray-700 dark:border-gray-600" />
    <span class="text-gray-700 dark:text-gray-300">{{ priority.label }}</span>
</label>
            <p class="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider px-3">Status</p>
<label v-for="status in statusOptions" :key="status.value" class="flex items-center space-x-2 px-3 py-1 text-sm">
    <input type="checkbox" :value="status.value" v-model="selectedStatus" class="rounded text-blue-500 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600" />
    <span class="text-gray-700 dark:text-gray-300">{{ status.label }}</span>
</label>
        </div>
    </div>
                      <div v-if="selectedTicket">
                          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Status</label>
                          <select
                              v-model="selectedTicket.status"
                              @change="updateTicketStatus"
                              :disabled="!selectedTicket.assignee"
                              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                              <option value="nao-atribuido">Não Atribuído</option>
                              <option value="em-andamento">Em Andamento</option>
                              <option value="resolvido">Resolvido</option>
                          </select>
                      </div>
                  </nav>
              </div>

              <!-- Main Content -->
              <div class="flex-1 flex flex-col overflow-hidden">
                  <!-- Header -->
                  <div class="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-4 lg:px-6">
                      <div class="flex items-center justify-between">
                          <div class="flex items-center space-x-4">
                              <button 
                                  @click="sidebarOpen = true"
                                  class="lg:hidden p-2 rounded-md text-gray-400 dark:text-gray-300 hover:text-gray-600 dark:hover:text-gray-100"
                              >
                                  <Menu class="w-6 h-6" />
                              </button>
                          </div>
                      </div>
                  </div>

                  <!-- Dashboard Stats -->
                  <!-- Dashboard Stats -->
    <!-- Substitua a seção do dashboard existente por esta: -->
    <DashboardMetrics :dark-mode="isDarkTheme"
      v-if="currentView === 'dashboard'" 
      :current-view="currentView" 
    />
                  <!-- Settings Screen -->
                  <SettingsScreen v-if="currentView === 'settings'" />

                  <!-- Filters and Search -->
                  <div v-if="currentView === 'tickets' && isTIUser" class="mt-6 px-4 lg:px-6 pb-4">
                      <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
                          <div class="space-y-4">
                              <div class="flex flex-col sm:flex-row sm:items-center sm:space-x-4 space-y-2 sm:space-y-0">
                                  <div class="relative flex-1">
                                      <Search class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-500 w-4 h-4" />
                                      <input
                                          type="text"
                                          placeholder="Buscar chamados..."
                                          v-model="searchQuery"
                                          @input="loadAllTickets"
                                          class="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                          />
                                  </div>
                                  <button 
                                      @click="showNewTicketModal = true"
                                      class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2"
                                  >
                                      <Plus class="w-4 h-4" />
                                      <span>Novo Chamado</span>
                                  </button>
                              </div>

                              
                              <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-3 sm:space-y-0 sm:space-x-4">

                                  <div class="flex items-center space-x-2">
                                      <button @click="clearFilters" class="p-2 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300">
                                          <Icon :iconNode="broom" class="w-5 h-5" />
                                      </button>
                                      <button @click="loadAllTickets" class="p-2 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300">
                                          <RefreshCw class="w-5 h-5" /></button>
                                  </div>
                              </div>
                              
                          </div>
                      </div>
                  </div>

                  <!-- Tickets List - MOBILE CARDS LAYOUT -->
                  <div v-if="currentView === 'tickets'" class="mt-6 flex-1 px-4 lg:px-6 pb-4 lg:pb-6 overflow-auto">
                    
                    <div class="bg-white dark:bg-gray-800 rounded-lg shadow lg:block">
                      <div class="px-4 lg:px-6 py-4 border-b border-gray-200 dark:border-gray-700">
                        <h3 class="text-lg font-medium text-gray-900 dark:text-white">
                          Chamados
                          <span class="text-sm text-gray-500 dark:text-gray-400">({{ filteredTickets.length }} de {{ totalItems }})</span>
                        </h3>
                      </div>
                      
                      <div v-if="filteredTickets.length === 0" class="p-8 text-center text-gray-400 dark:text-gray-500 text-lg">
                        Nenhum chamado aqui ✅
                      </div>

                      <!-- Mobile Card Layout -->
                      <div class="lg:hidden">
                        <div class="grid gap-4 p-4">
                          <div 
                            v-for="ticket in filteredTickets"
                            :key="ticket.id"
                            class="bg-white dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 shadow-sm hover:shadow-md transition-shadow cursor-pointer"
                            @click="selectTicket(ticket)"
                          >
                            <div class="p-4">
                              <!-- Card Header -->
                              <div class="flex items-start justify-between mb-3">
                                <div class="flex items-center space-x-2">
                                  <div class="w-8 h-8 bg-blue-100 dark:bg-blue-900/50 rounded-full flex items-center justify-center">
                                    <span class="text-xs font-medium text-blue-600 dark:text-blue-300">#{{ ticket.id }}</span>
                                  </div>
                                  <span
                                    :class="getStatusClass(ticket.status)"
                                    class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                                  >
                                    {{ formatStatus(ticket.status) }}
                                  </span>
                                </div>
                                <span
                                  :class="getPriorityClass(ticket.priority)"
                                  class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                                >
                                  {{ formatPriority(ticket.priority) }}
                                </span>
                              </div>

                              <!-- Card Title -->
                              <h4 class="font-medium text-gray-900 dark:text-white mb-2 line-clamp-2">
                                {{ ticket.title }}
                              </h4>

                              <!-- Card Description -->
                              <p class="text-sm text-gray-600 dark:text-gray-400 mb-3 line-clamp-2">
                                {{ ticket.description }}
                              </p>

                              <!-- Card Tags -->
                              <div class="flex flex-wrap gap-2 mb-3">
                                <span v-if="ticket.id_externo" class="bg-purple-100 text-purple-800 text-xs font-medium px-2 py-1 rounded dark:bg-purple-900 dark:text-purple-300">
                                  Chat: {{ ticket.id_externo }}
                                </span>
                                <span class="bg-gray-100 text-gray-800 text-xs font-medium px-2 py-1 rounded dark:bg-gray-700 dark:text-gray-300">
                                  {{ ticket.sistema }}
                                </span>
                                <span v-if="ticket.tipo" class="bg-blue-100 text-blue-800 text-xs font-medium px-2 py-1 rounded dark:bg-blue-900 dark:text-blue-300">
                                  {{ ticket.tipo }}
                                </span>
                              </div>

                              <!-- Card Footer -->
                              <div class="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400">
                                <div class="flex items-center space-x-1">
                                  <Clock class="w-3 h-3" />
                                  <span>{{ formatDate(ticket.created) }}</span>
                                </div>
                                <div class="flex items-center space-x-2">
                                  <div v-if="ticket.assignee" class="flex items-center space-x-1">
                                    <div class="w-5 h-5 bg-blue-100 dark:bg-blue-900/50 rounded-full flex items-center justify-center">
                                      <span class="text-xs font-medium text-blue-600 dark:text-blue-300">{{ ticket.assignee.charAt(0) }}</span>
                                    </div>
                                    <span class="text-xs">{{ ticket.assignee }}</span>
                                  </div>
                                  <span v-else class="text-xs text-gray-400 dark:text-gray-500">Não atribuído</span>
                                </div>
                              </div>

                              <!-- SLA Warning -->
                              <div
                                v-if="ticket.slaStatus !== 'ok'"
                                :class="ticket.slaStatus === 'critical'
                                  ? 'text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20'
                                  : 'text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-900/20'"
                                class="flex items-center space-x-1 mt-2 p-2 rounded text-xs"
                              >
                                <AlertTriangle class="w-3 h-3" />
                                <span>
                                  SLA {{ ticket.slaStatus === 'critical' ? 'expirado' : 'em risco' }}: {{ ticket.slaTime }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Desktop List Layout (unchanged) -->
                      <div class="hidden lg:block divide-y divide-gray-200 dark:divide-gray-700">
                        <div v-for="ticket in filteredTickets"
                          :key="ticket.id"
                          class="p-4 lg:p-6 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer"
                          @click="selectTicket(ticket)"
                        >
                         <div class="flex items-start justify-between">
                            <div class="flex items-start space-x-4 flex-1">
                              
                              <div class="flex-shrink-0">
                                <div class="w-10 h-10 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center">
                                  <span class="text-sm font-medium text-gray-600 dark:text-gray-300">#{{ ticket.id }}</span>
                                </div>
                              </div>

                              <div class="flex-1 min-w-0">
                                <div class="flex items-center space-x-2 mb-1">
                                  <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.title }}</p>
                                  
                                  <span v-if="ticket.id_externo" class="bg-purple-100 text-purple-800 text-xs font-medium px-2 py-0.5 rounded dark:bg-purple-900 dark:text-purple-300">
                                      Chat: {{ ticket.id_externo }}
                                  </span>

                                  <span
                                    :class="getPriorityClass(ticket.priority)"
                                    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                                  >
                                    {{ formatPriority(ticket.priority) }}
                                  </span>
                                </div>
                                <p class="text-sm text-gray-500 dark:text-gray-400 mb-2">{{ ticket.description }}</p>
                              <div class="flex items-center space-x-4 text-xs text-gray-500 dark:text-gray-400">
        <span class="flex items-center space-x-1">
          <Clock class="w-3 h-3" />
          <span>{{ formatDate(ticket.created) }}</span>
        </span>
        <span class="flex items-center space-x-1">
          <Tag class="w-3 h-3" />
          <span>{{ ticket.sistema }}</span>
        </span>
        <!-- Adicione aqui -->
        <span v-if="ticket.tipo" class="flex items-center space-x-1">
          <User class="w-3 h-3" />
          <span>Tipo: {{ ticket.tipo }}</span>
        </span>

          <span v-if="ticket.requester" class="flex items-center space-x-1">
          <User class="w-3 h-3" />
          <span>Requisitante: {{ ticket.requester }}</span>
        </span>

        <span v-if="ticket.unidadeNome" class="flex items-center space-x-1">
          <span>Unidade: {{ ticket.unidadeNome }}</span>
        </span>
          <span
            v-if="ticket.slaStatus !== 'ok'"
            :class="ticket.slaStatus === 'critical'
              ? 'text-red-600 dark:text-red-400'
              : 'text-yellow-600 dark:text-yellow-400'"
            class="flex items-center space-x-1"
          >
            <AlertTriangle class="w-3 h-3" />
            <span>
              SLA {{ ticket.slaStatus === 'critical' ? 'expirado' : 'em risco' }}: {{ ticket.slaTime }}
            </span>
          </span>
        </div>
                              </div>
                            </div>
                            
                            <div class="flex flex-col items-end space-y-2">
                              <span
                                :class="getStatusClass(ticket.status)"
                                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                              >
                                {{ formatStatus(ticket.status) }}
                              </span>
                              <div v-if="ticket.assignee" class="flex items-center space-x-1">
                                <div class="w-6 h-6 bg-blue-100 dark:bg-blue-900/50 rounded-full flex items-center justify-center">
                                  <span class="text-xs font-medium text-blue-600 dark:text-blue-300">{{ ticket.assignee.charAt(0) }}</span>
                                </div>
                                <span class="text-xs text-gray-500 dark:text-gray-400">{{ ticket.assignee }}</span>
                              </div>
                              <span v-else class="text-xs text-gray-400 dark:text-gray-500">Não atribuído</span>
                            </div>
                          </div>
                          
                        </div>
                      </div>
                    </div>

                    <!-- Pagination -->
                    <div class="flex flex-col md:flex-row md:items-center md:justify-between my-4 gap-2">
                      <div class="flex items-center gap-2 justify-center">
                        <button
                          :disabled="currentPage === 1"
                          @click="handlePageChange(currentPage - 1)"
                          class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 disabled:opacity-50"
                        >
                          Anterior
                        </button>

                        <span class="text-sm text-gray-700 dark:text-gray-200">
                          Página {{ currentPage }} de {{ totalPages }}
                        </span>

                        <button
                          :disabled="currentPage >= totalPages"
                          @click="handlePageChange(currentPage + 1)"
                          class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 disabled:opacity-50"
                        >
                          Próxima
                        </button>
                      </div>
                      <div class="flex items-center gap-2 justify-center">
                        <label for="page-size" class="text-sm text-gray-700 dark:text-gray-200">Itens por página:</label>
                        <select id="page-size" :value="itemsPerPage"
                          @change="handleItemsPerPageChange(Number($event.target.value))"
                          class="rounded border px-2 py-1 text-sm dark:bg-gray-700 dark:text-white">
                          <option :value="5">5</option>
                          <option :value="10">10</option>
                          <option :value="20">20</option>
                          <option :value="50">50</option>
                        </select>
                        <span v-if="totalItems !== undefined && totalItems !== null"
                          class="text-xs text-gray-500 dark:text-gray-400">Total: {{ totalItems }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- My Assigned Tickets - MOBILE CARDS LAYOUT -->
                  <div v-if="currentView === 'myAssigned'" class="flex-1 px-4 lg:px-6 pb-4 lg:pb-6 overflow-auto">
                    <div class="bg-white dark:bg-gray-800 rounded-lg shadow">
                      <!-- Header -->
                      <div class="mt-6 flex items-center justify-between mb-4 px-4 lg:px-6 py-4 border-b border-gray-200 dark:border-gray-700">
                        <h3 class="text-lg font-medium text-gray-900 dark:text-white">
                          {{ isTIUser
                            ? `Meus Chamados Atribuídos (${myAssignedTickets.length})`
                            : `Meus Chamados Criados (${myAssignedTickets.length})`
                          }}
                        </h3>
                        <button @click="showNewTicketModal = true" class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2">
                          <Plus class="w-4 h-4"/><span>Novo Chamado</span>
                        </button>
                      </div>

                      <div v-if="myAssignedTickets.length === 0" class="p-8 text-center text-gray-400 dark:text-gray-500 text-lg">
                        Nenhum chamado aqui ✅
                      </div>

                      <!-- Mobile Card Layout for My Assigned -->
                      <div class="lg:hidden">
                        <div class="grid gap-4 p-4">
                          <div 
                            v-for="ticket in myAssignedTickets"
                            :key="ticket.id"
                            class="bg-white dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 shadow-sm hover:shadow-md transition-shadow cursor-pointer"
                            @click="selectTicket(ticket)"
                          >
                            <div class="p-4">
                              <!-- Card Header -->
                              <div class="flex items-start justify-between mb-3">
                                <div class="flex items-center space-x-2">
                                  <div class="w-8 h-8 bg-blue-100 dark:bg-blue-900/50 rounded-full flex items-center justify-center">
                                    <span class="text-xs font-medium text-blue-600 dark:text-blue-300">#{{ ticket.id }}</span>
                                  </div>
                                  <span
                                    :class="getStatusClass(ticket.status)"
                                    class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                                  >
                                    {{ formatStatus(ticket.status) }}
                                  </span>
                                </div>
                                <span
                                  :class="getPriorityClass(ticket.priority)"
                                  class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                                >
                                  {{ formatPriority(ticket.priority) }}
                                </span>
                              </div>

                              <!-- Card Title -->
                              <h4 class="font-medium text-gray-900 dark:text-white mb-2 line-clamp-2">
                                {{ ticket.title }}
                              </h4>

                              <!-- Card Description -->
                              <p class="text-sm text-gray-600 dark:text-gray-400 mb-3 line-clamp-2">
                                {{ ticket.description }}
                              </p>

                              <!-- Card Tags -->
                              <div class="flex flex-wrap gap-2 mb-3">
                                <span v-if="ticket.id_externo" class="bg-purple-100 text-purple-800 text-xs font-medium px-2 py-1 rounded dark:bg-purple-900 dark:text-purple-300">
                                  Chat: {{ ticket.id_externo }}
                                </span>
                                <span class="bg-gray-100 text-gray-800 text-xs font-medium px-2 py-1 rounded dark:bg-gray-700 dark:text-gray-300">
                                  {{ ticket.sistema }}
                                </span>
                              </div>

                              <!-- Card Footer -->
                              <div class="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400">
                                <div class="flex items-center space-x-1">
                                  <Clock class="w-3 h-3" />
                                  <span>{{ formatDate(ticket.created) }}</span>
                                </div>
                                <div class="flex items-center space-x-2">
                                  <div v-if="ticket.assignee" class="flex items-center space-x-1">
                                    <div class="w-5 h-5 bg-blue-100 dark:bg-blue-900/50 rounded-full flex items-center justify-center">
                                      <span class="text-xs font-medium text-blue-600 dark:text-blue-300">{{ ticket.assignee.charAt(0) }}</span>
                                    </div>
                                    <span class="text-xs">{{ ticket.assignee }}</span>
                                  </div>
                                  <span v-else class="text-xs text-gray-400 dark:text-gray-500">Não atribuído</span>
                                </div>
                              </div>

                              <!-- SLA Warning -->
                              <div
                                v-if="ticket.slaStatus && ticket.slaStatus !== 'ok'"
                                :class="getSlaClass(ticket.slaStatus)"
                                class="flex items-center space-x-1 mt-2 p-2 rounded text-xs bg-opacity-10"
                              >
                                <Timer class="w-3 h-3" />
                                <span>{{ ticket.slaTime }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Desktop List Layout for My Assigned (unchanged) -->
                      <div class="hidden lg:block divide-y divide-gray-200 dark:divide-gray-700">
                        <div
                          v-for="ticket in myAssignedTickets"
                          :key="ticket.id"
                          class="p-4 lg:p-6 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer"
                          @click="selectTicket(ticket)"
                        >
                          <div class="flex items-start justify-between">
                              <div class="flex items-start space-x-4 flex-1">
                                  <div class="flex-shrink-0">
                                      <div class="w-10 h-10 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center">
                                          <span class="text-sm font-medium text-gray-600 dark:text-gray-300">#{{ ticket.id }}</span>
                                      </div>
                                  </div>
                                  <div class="flex-1 min-w-0">
                                      <div class="flex items-center space-x-2 mb-1">
                                          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.title }}</p>
                                            <span v-if="ticket.id_externo" class="bg-purple-100 text-purple-800 text-xs font-medium px-2 py-0.5 rounded dark:bg-purple-900 dark:text-purple-300">
                                        Chat: {{ ticket.id_externo }}
                                    </span>
                                          <span
                                              :class="getPriorityClass(ticket.priority)"
                                              class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                                          >
                                              {{ ticket.priority }}
                                          </span>
                                      </div>
                                      <p class="text-sm text-gray-500 dark:text-gray-400 mb-2">{{ ticket.description }}</p>
                                      <div class="flex items-center space-x-4 text-xs text-gray-500 dark:text-gray-400">
                                          <span class="flex items-center space-x-1">
                                              <Clock class="w-3 h-3" />
                                              <span>{{ ticket.created }}</span>
                                          </span>
                                          <span class="flex items-center space-x-1">
                                              <Tag class="w-3 h-3" />
                                              <span>{{ ticket.sistema }}</span>
                                          </span>
                                          <span v-if="ticket.slaStatus" :class="getSlaClass(ticket.slaStatus)" class="flex items-center space-x-1">
                                              <Timer class="w-3 h-3" />
                                              <span>{{ ticket.slaTime }}</span>
                                          </span>
                                      </div>
                                  </div>
                              </div>
                              <div class="flex flex-col items-end space-y-2">
                                  <span
                                      :class="getStatusClass(ticket.status)"
                                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                                  >
                                      {{ ticket.status }}
                                  </span>
                                  <div v-if="ticket.assignee" class="flex items-center space-x-1">
                                      <div class="w-6 h-6 bg-blue-100 dark:bg-blue-900/50 rounded-full flex items-center justify-center">
                                          <span class="text-xs font-medium text-blue-600 dark:text-blue-300">{{ ticket.assignee.charAt(0) }}</span>
                                      </div>
                                      <span class="text-xs text-gray-500 dark:text-gray-400">{{ ticket.assignee }}</span>
                                  </div>
                                  <span v-else class="text-xs text-gray-400 dark:text-gray-500">Não atribuído</span>
                              </div>
                          </div>
                        </div>
                      </div>

                      <!-- Pagination for My Assigned -->
                      <div class="flex flex-col md:flex-row md:items-center md:justify-between my-4 gap-2">
                        <div class="flex items-center gap-2 justify-center">
                          <button :disabled="currentPage === 1" @click="handlePageChange(currentPage - 1)"
                            class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 disabled:opacity-50">Anterior</button>
                          <span class="text-sm text-gray-700 dark:text-gray-200">Página {{ currentPage }} de {{ totalPages }}</span>
                          <button :disabled="currentPage === totalPages"
                            @click="handlePageChange(currentPage + 1)"
                            class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 disabled:opacity-50">Próxima</button>
                        </div>
                        <div class="flex items-center gap-2 justify-center">
                          <label for="page-size-my" class="text-sm text-gray-700 dark:text-gray-200">Itens por página:</label>
                          <select id="page-size-my" :value="itemsPerPage"
                            @change="handleItemsPerPageChange(Number($event.target.value))"
                            class="rounded border px-2 py-1 text-sm dark:bg-gray-700 dark:text-white">
                            <option :value="5">5</option>
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="50">50</option>
                          </select>
                          <span v-if="totalItems !== undefined && totalItems !== null"
                            class="text-xs text-gray-500 dark:text-gray-400">Total: {{ totalItems }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>

          <!-- New Ticket Modal -->
          <div v-if="showNewTicketModal" class="fixed inset-0 z-50 overflow-y-auto bg-gray-500 bg-opacity-75 transition-opacity">
              <div class="flex items-center justify-center min-h-screen p-4">
                  <div 
                      class="bg-white dark:bg-gray-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:max-w-2xl sm:w-full"
                      @click.stop >
                      <div class="bg-white dark:bg-gray-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                          <div class="flex items-center justify-between mb-4">
                              <h3 class="text-lg font-medium text-gray-900 dark:text-white">Novo Chamado</h3>
                              <button @click="showNewTicketModal = false" class="text-gray-400 dark:text-gray-300 hover:text-gray-600 dark:hover:text-gray-100">
                                  <X class="w-5 h-5" />
                              </button>
                          </div>
                          
                          <form @submit.prevent="createTicket" class="space-y-4">
                              <div v-if="isTIUser" class="mb-4">
                              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Requisitante</label>
                              <select v-model.number="newTicket.requisitante" class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 text-sm">
                                  <option :value="null">Selecione o usuário</option>
                                  <option v-for="user in allUsers" :key="user.id" :value="user.id">
                                  {{ user.first_name && user.last_name ? user.first_name + ' ' + user.last_name : user.username }}
                                  </option>
                              </select>
                              </div>
                              <div>
  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Unidade</label>
  <select v-model.number="newTicket.unidadeId" class="w-full px-3 py-2 border ...">
    <option :value="null">Selecione a unidade</option>
    <option v-for="u in unidades" :key="u.id" :value="u.id">{{ u.nome }}</option>
  </select>
</div>
                              <div>
                                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Título</label>
                                  <input 
                                      type="text" 
                                      v-model="newTicket.title"
                                      class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                      required
                                  />
                              </div>
                                 <div>
                                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Sistema</label>
                                  <select 
                                      v-model="newTicket.sistema"
                                      required
                                      class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                  >
                                      <option value="">Selecione o sistema</option>
                                      <option v-for="sistema in sistemas" :key="sistema.id" :value="sistema.nome">{{ sistema.nome }}</option>
                                  </select>
                              </div>
                              <div>
                                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Descrição</label>
                                  <textarea 
                                      v-model="newTicket.description"
                                      rows="4"
                                      class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                      required
                                  ></textarea>
                              </div>
                              <div>
                                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Anexos</label>
                                  <div class="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 dark:border-gray-600 border-dashed rounded-lg">
                                      <div class="space-y-1 text-center">
                                          <Upload class="mx-auto h-12 w-12 text-gray-400 dark:text-gray-500" />
                                          <div class="flex text-sm text-gray-600 dark:text-gray-400">
                                              <label class="relative cursor-pointer bg-white dark:bg-gray-800 rounded-md font-medium text-blue-600 dark:text-blue-400 hover:text-blue-500 dark:hover:text-blue-300">
                                                  <span>Enviar arquivos</span>
                                                  <input type="file" class="sr-only" multiple @change="handleFileUpload" />
                                              </label>
                                              <p class="pl-1">ou arraste e solte</p>
                                          </div>
                                          <p class="text-xs text-gray-500 dark:text-gray-400">PNG, JPG, PDF até 10MB</p>
                                      </div>
                                  </div>
                                  <div v-if="newTicket.attachments.length > 0" class="mt-2 space-y-1">
                                      <div v-for="(file, index) in newTicket.attachments" :key="index" class="flex items-center justify-between text-sm text-gray-600 dark:text-gray-400">
                                          <span>{{ file.name }}</span>
                                          <button @click="removeAttachment(index)" class="text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300">
                                              <X class="w-4 h-4" />
                                          </button>
                                      </div>
                                  </div>
                              </div>

                              <div class="flex justify-end space-x-3 pt-4">
                                  <button 
                                      type="button" 
                                      @click="showNewTicketModal = false"
                                      class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600"
                                  >
                                      Cancelar
                                  </button>
                                  <button 
                                      type="submit"
                                      class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700"
                                  >
                                      Criar Chamado
                                  </button>
                              </div>
                          </form>
                      </div>
                  </div>
              </div>
          </div>
          </div>
      </template>
      
  </BaseTemplate>
  <router-view />
</template>

<script setup>
import BaseTemplate from '../templates/BaseTemplate.vue';
import apiClient from '@/services/authService';
import SettingsScreen from './SettingsScreen.vue';
import DashboardMetrics from './DashboardMetrics.vue'
import { broom } from '@lucide/lab';
import {
  Icon,
  LayoutDashboard,
  Ticket,
  Clock,
  AlertTriangle,
  Search,
  RefreshCw,
  Plus,
  Headset,
  Menu,
  X,
  User,
  Tag,
  Timer,
  Upload,
  Settings
} from 'lucide-vue-next';
import { ref, computed, watch, reactive, onMounted } from 'vue';
import { useUserStore } from '@/stores/userStore';
import { usePerfilStore } from '@/stores/settings/perfilStore';
import { useFilasStore } from '@/stores/tickets/filasStore';
import { useRouter } from 'vue-router';


const slas = ref([])
const filasStore = useFilasStore();
const filas = computed(() => filasStore.filas);
const selectedQueues = reactive({});
const currentPage = ref(1);
const itemsPerPage = ref(10);
const totalItems = ref(0);
const allUsers = ref([]);
const tiposChamado = ref([]);
const totalPages = computed(() => {
  // garante pelo menos 1 página
  return Math.max(1, Math.ceil(totalItems.value / itemsPerPage.value))
})

function handlePageChange(newPage) {
  // não faz nada se sair do intervalo
  if (newPage < 1 || newPage > totalPages.value) return
  currentPage.value = newPage
  loadAllTickets()
}

async function loadTiposChamado() {
try {
  const { data } = await apiClient.get('/api/v1/tickets/tipos/');
  tiposChamado.value = data;
} catch (e) {
  tiposChamado.value = [];
}
}

async function loadSlas() {
  try {
    const { data } = await apiClient.get('/api/v1/tickets/slas/')
    slas.value = data
  } catch (e) {
    console.error('Erro ao carregar SLAs:', e)
  }
}

async function loadAllTickets() {
  loadingTickets.value = true
  errorTickets.value = null

  try {
    const { data } = await apiClient.get('/api/v1/tickets/', {
      params: {
        page: currentPage.value,
        per_page: itemsPerPage.value,
        search: searchQuery.value,
        status: statusFilter.value,
        priority: priorityFilter.value,
        queue: queueFilter.value,
      },
    })

    tickets.value = data.results.map(t => {
      const ticket = {
        id: t.id,
        title: t.titulo,
        description: t.descricao,
        requester: t.criado_por,
        assignee: t.analista,
        assigneeId: t.analista_id,
        status: t.status,
        priority: t.prioridade,
        queue: t.fila?.nome || '',
        tipo: t.tipo,
        sistema: t.sistema,
        created: t.data_criacao,
        slaStatus: t.sla_status,
        totalTime: t.total_time, 
        slaTime: t.sla_time,
        unidadeId: t.unidade || null,
        unidadeNome: (() => {
          const u = unidades.value.find(x => x.id === t.unidade)
          return u ? u.nome : ''
        })(),
      }
      return ticket
    })

    totalItems.value = data.total_count
  } catch (e) {
    console.error('Erro ao buscar tickets:', e)
    errorTickets.value = e.message
  } finally {
    loadingTickets.value = false
  }
}

function handleItemsPerPageChange(newItemsPerPage) {
  itemsPerPage.value = newItemsPerPage
  currentPage.value   = 1
  loadAllTickets()
}

const statusOptions = [
  { value: 'nao-atribuido', label: 'Não Atribuído' },
  { value: 'em-andamento', label: 'Em Andamento' },
  { value: 'resolvido', label: 'Resolvido' }
];
const priorityOptions = [
  { value: 'baixa', label: 'Baixa' },
  { value: 'media', label: 'Média' },
  { value: 'alta', label: 'Alta' }
];

const selectedStatus = ref([]);
const selectedPriorities = ref([]);
const selectedFilas = ref([]);
// Reactive data
const searchQuery = ref('');
const statusFilter = ref('');
const priorityFilter = ref('');
const queueFilter = ref('');
const sidebarOpen = ref(false);
const currentView = ref('dashboard');


const metrics = ref({
  total_chamados: 0,
  chamados_nao_atribuido: 0,
  chamados_em_andamento: 0,
  chamados_resolvidos: 0,
  tempo_medio_resposta: 0,
  tempo_medio_resolucao: 0,
  chamados_por_tipo: [],
  chamados_por_fila: [],
  sla_stats: [],
});

async function loadMetrics() {
  try {
    const { data } = await apiClient.get('/api/v1/tickets/metrics');
    metrics.value = data;
  } catch (e) {
    console.error('Erro ao carregar métricas:', e);
  }
}

onMounted(() => {
  loadMetrics();
});

watch([selectedStatus, selectedPriorities, selectedFilas], () => {
  // Sempre pega o primeiro valor selecionado (backend atual só aceita um valor por filtro)
  statusFilter.value   = selectedStatus.value.length   > 0 ? selectedStatus.value[0]   : '';
  priorityFilter.value = selectedPriorities.value.length > 0 ? selectedPriorities.value[0] : '';
  queueFilter.value    = selectedFilas.value.length    > 0 ? selectedFilas.value[0]    : '';
  loadAllTickets();
});

const showNewTicketModal = ref(false);
watch(showNewTicketModal, async (val) => {
if (val && isTIUser.value) {
  try {
    const res = await apiClient.get('/api/v1/auth/users/');
    allUsers.value = res.data;
  } catch (e) {
    console.error('Erro ao buscar usuários para requisitante:', e);
    allUsers.value = [];
  }
}
});
const selectedTicket = ref(null);

const priorityLabels = {
  baixa:  'Baixa',
  media:  'Média',
  alta:   'Alta',
};

const statusLabels = {
  'nao-atribuido': 'Não Atribuído',
  'em-andamento':  'Em Andamento',
  resolvido:      'Resolvido',
};

const formatPriority = key => priorityLabels[key] || key;
const formatStatus   = key => statusLabels[key]   || key;
// New ticket form
const newTicket = ref({
  title: '',
  description: '',
  attachments: [],
  sistema: '',
  fila: '',
  tipo: '',
  requisitante: null, 
  unidadeId: null,
});

const tickets = ref([]);
const loadingTickets = ref(true);
const errorTickets = ref(null);
const ticketCreationLoading = ref(false);
const ticketCreationError = ref(null);
const assignableUsers = ref([]);
const unidades = ref([]);


async function loadUnidades() {
try {
  const res = await apiClient.get('/api/v1/enterprises/'); // ajuste a rota se necessário
  unidades.value = res.data; // [{ id, nome }, …]
} catch (e) {
  console.error('Erro ao carregar unidades:', e);
}
}

const sistemas = ref([]);
const userStore = useUserStore();
const isTIUser  = computed(() => userStore.grupos && userStore.grupos.includes('ti'));
const perfilStore = usePerfilStore(); 
const router = useRouter();

function formatDate(isoString) {
if (!isoString) return '';
const dt = new Date(isoString);
return dt.toLocaleString('pt-BR', {
  day:   '2-digit',
  month: '2-digit',
  year:  'numeric',
  hour:   '2-digit',
  minute: '2-digit',
  hour12: false
});
}

onMounted(async () => {
  await loadSlas()
  await loadAllTickets()
  await loadTiposChamado();
  loadUnidades();
try {
  if (typeof userStore.fetchUser === 'function') {
    await userStore.fetchUser();
  }

  await Promise.all([
    filasStore.loadFilas(),
    loadAllTickets(),
    (async () => {
      filas.value.forEach(f => {
        if (!(f.nome in selectedQueues)) {
          selectedQueues[f.nome] = false;
        }
      });
      const { data: systemsData } = await apiClient.get('/api/v1/tickets/systems/');
      sistemas.value = systemsData;
    })(),
    // Adicione a busca de analistas aqui!
    async () => {
      try {
        const response = await apiClient.get('/api/v1/tickets/analysts/'); // Endpoint que você criou
        assignableUsers.value = response.data; // Popula a lista principal de analistas
      } catch (error) {
        console.error("Erro ao carregar analistas:", error);
      }
    }
  ]);
} catch (error) {
  console.error("Falha ao inicializar os dados do componente:", error);
}
if (isTIUser.value) {
  const res = await apiClient.get('/api/v1/auth/users/'); // Crie esse endpoint se não existir
  allUsers.value = res.data; // [{id, nome}]
}
});


const filteredTickets = computed(() => {
  return tickets.value.filter(ticket => {
    const matchesStatus = selectedStatus.value.length === 0 || selectedStatus.value.includes(ticket.status);
    const matchesPriority = selectedPriorities.value.length === 0 || selectedPriorities.value.includes(ticket.priority);
    const matchesFila = selectedFilas.value.length === 0 || selectedFilas.value.includes(ticket.queue);
    const matchesSearch = !searchQuery.value ||
      ticket.title.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
      ticket.description.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
      ticket.requester.toLowerCase().includes(searchQuery.value.toLowerCase());
    return matchesStatus && matchesPriority && matchesFila && matchesSearch;
  });
});

const myAssignedTickets = computed(() => {
// O id do usuário logado vem da perfilStore (perfilStore.id)
const currentUserId = perfilStore.id; 

if (!currentUserId) {
  console.warn('Filtro interrompido: ID do usuário está nulo ou indefinido.');
  return [];
}

return tickets.value.filter(ticket => {
  // Se o usuário for um usuário TI, filtre pelo ID do analista atribuído
  if (isTIUser.value) {
    // Compare o ID do analista do chamado com o ID do usuário logado
    return ticket.assigneeId === currentUserId;
  }

    const currentUserName = `${perfilStore.firstName} ${perfilStore.lastName}`.trim();
    return ticket.requester === currentUserName;
  });
});

// Methods
const getPriorityClass = (priority) => {
    const classes = {
        'baixa': 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
        'media': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/50 dark:text-yellow-300',
        'alta': 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-300'
    };
    return classes[priority] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
};

const getStatusClass = (status) => {
  const classes = {
      'nao-atribuido': 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
      'em-andamento': 'bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-300',
      'resolvido': 'bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300'
  };
  return classes[status] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
};

const getSlaClass = (slaStatus) => {
  const classes = {
      'ok': 'text-green-600 dark:text-green-400',
      'warning': 'text-yellow-600 dark:text-yellow-400',
      'critical': 'text-red-600 dark:text-red-400'
  };
  return classes[slaStatus] || 'text-gray-600 dark:text-gray-400';
};


const clearFilters = () => {
  searchQuery.value = '';
  statusFilter.value = '';
  priorityFilter.value = '';
  queueFilter.value = '';
};


const selectTicket = (ticket) => {
  router.push({ name: 'TicketsDetalhes', params: { id: ticket.id } });
};

function showMyAssigned() {
currentView.value = 'myAssigned';
loadAllTickets();    // ou o nome da sua função que faz `apiClient.get('/api/v1/tickets')`
}

const handleFileUpload = (event) => {
  const files = Array.from(event.target.files);
  newTicket.value.attachments.push(...files);
};

const removeAttachment = (index) => {
  newTicket.value.attachments.splice(index, 1);
};

const createTicket = async () => {
  ticketCreationLoading.value = true;
  ticketCreationError.value = null;

  try {
      let imagem_base64 = '';
      if (newTicket.value.attachments.length > 0) {
          const file = newTicket.value.attachments[0];
          if (file && file.type.startsWith('image/')) {
              imagem_base64 = await fileToBase64(file);
          }
      }

      const payload = {
          titulo: newTicket.value.title,
          descricao: newTicket.value.description,
          sistema: newTicket.value.sistema,
          tipo: newTicket.value.tipo,
          fila: newTicket.value.fila,
          imagem_base64: imagem_base64,
          unidade: newTicket.value.unidadeId,
          requisitante: isTIUser.value ? newTicket.value.requisitante : undefined,
      };

      const response = await apiClient.post('/api/v1/tickets/chamados', payload);
          close(); // Fecha o modal
          window.location.reload();

      if (!response.ok) {
          const errorData = await response.json();
          showNewTicketModal.value = false; // Fecha o modal mesmo em erro
          throw new Error(errorData.detail || 'Erro ao criar chamado');
      }

      const ticket = await response.json();

      // Limpa filtros para garantir que o novo chamado apareça
      searchQuery.value = '';
      statusFilter.value = '';
      priorityFilter.value = '';
      queueFilter.value = '';

      tickets.value.unshift({
          id: ticket.id,
          title: ticket.titulo,
          description: ticket.descricao,
          requester: ticket.criado_por,
          assignee: ticket.analista,
          status: ticket.status,
          priority: ticket.prioridade,
          queue: typeof ticket.fila === 'object' ? ticket.fila.nome : ticket.fila,
          sistema: ticket.sistema,
          created: ticket.data_criacao,
          tipo: ticket.tipo,
          image: ticket.imagem_base64,
          slaStatus: '',
          slaTime: '',
          totalTime: '',
          comments: []
      });

      newTicket.value = {
          title: '',
          description: '',
          attachments: [],
          sistema: '',
          fila: '',
          tipo: '',
          requisitante: null
      };

      showNewTicketModal.value = false; 

  } catch (e) {
      console.error("Erro detalhado ao criar chamado:", e);
      ticketCreationError.value = e.message;
  } finally {
      ticketCreationLoading.value = false;
  }
};

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(',')[1]);
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
  });
}


const ticketUpdateLoading = ref(false);
const ticketUpdateError = ref(null);

async function updateTicketFields(fields) {
if (!selectedTicket.value) return;
ticketUpdateLoading.value = true;
ticketUpdateError.value = null;

try {
  const ticket = tickets.value.find(t => t.id === selectedTicket.value.id);
  if (!ticket) throw new Error('Ticket não encontrado');


  // Use o ID do analista já atribuído, se houver
  let currentAnalystId = selectedTicket.value.assigneeId;
  // Se não houver, tente buscar pelo nome no assignableUsers
  if (!currentAnalystId && selectedTicket.value.assignee) {
    const found = assignableUsers.value.find(a => a.nome === selectedTicket.value.assignee);
    currentAnalystId = found ? found.id : null;
  }

  const payload = {
    titulo:      ticket.title,
    descricao:   ticket.description,
    sistema:     ticket.sistema,
    tipo:        fields.tipo !== undefined ? fields.tipo : selectedTicket.value.tipo,
    prioridade:  ticket.priority,
    imagem_base64: '',
    status:      ticket.status,
    fila:        ticket.queue,
    analista:    currentAnalystId,
    unidade:     fields.unidade_id !== undefined ? fields.unidade_id : ticket.unidadeId,
  };

  if (fields.status   !== undefined) payload.status     = fields.status;
  if (fields.fila     !== undefined) payload.fila       = fields.fila;
  if (fields.priority !== undefined) payload.prioridade = fields.priority;
  if (fields.analista !== undefined) payload.analista   = fields.analista;
  const response = await apiClient.put(
    `/api/v1/tickets/chamados/${ticket.id}`,
    payload
  );
  const updated = response.data;

  // Atualize o ticket na lista principal
  Object.assign(ticket, {
    status:    updated.status,
    queue:     updated.fila  ? updated.fila.nome : '',
    filaId:    updated.fila  ? updated.fila.id   : null,
    priority:  updated.prioridade,
    assignee:  updated.analista,
    assigneeId: updated.analista_id,
    unidadeId: updated.unidade || null,
    unidadeNome: (() => {
      const unidadeObj = unidades.value.find(u => u.id === updated.unidade);
      return unidadeObj ? unidadeObj.nome : '';
    })(),
    tipo: updated.tipo
  });

  // Atualize o ticket selecionado
  Object.assign(selectedTicket.value, ticket);

} catch (e) {
  ticketUpdateError.value = e.message;
  console.error('Erro ao atualizar ticket:', e);
} finally {
  ticketUpdateLoading.value = false;
}
}

const updateTicketStatus = () =>
updateTicketFields({ status: selectedTicket.value.status });


</script>
